/**
 * Tenant filtering helpers — filter agent lists by tenant ID.
 */

import type { AgentsListResult } from "./types.ts";

/**
 * Filter agents list to only show agents matching the given tenant ID.
 * - Empty tenantId → show all agents (backward compatible, single-user mode)
 * - Non-empty tenantId → show only the agent whose ID matches tenantId
 *
 * Returns a new AgentsListResult with filtered agents, adjusting defaultId if needed.
 */
export function filterAgentsByTenant(
  agentsList: AgentsListResult | null,
  tenantId: string,
): AgentsListResult | null {
  if (!agentsList || !tenantId.trim()) {
    return agentsList;
  }

  const id = tenantId.trim();
  const filtered = agentsList.agents.filter((agent) => agent.id === id);

  return {
    agents: filtered,
    defaultId: filtered.length > 0 ? id : agentsList.defaultId,
  };
}
